import * as React from "react";

function DownLeftAndUpRightToCenterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M488.1 23.03c-9.375-9.375-24.56-9.375-33.94 0l-81.38 81.38-47.03-47.03a31.986 31.986 0 0 0-22.63-9.35c-4.117 0-8.275.792-12.24 2.413a31.985 31.985 0 0 0-19.75 29.56v135.1c0 13.25 10.74 23.1 24 23.1h136c12.94 0 24.63-7.797 29.56-19.75a31.952 31.952 0 0 0-6.938-34.87l-47.04-47.03 81.38-81.38C498.3 47.59 498.3 32.41 488.1 23.03zM215.1 272h-136c-12.94 0-24.63 7.797-29.56 19.75-4.07 11.95-1.32 25.75 7.83 34.85l47.04 47.03-81.38 81.38c-9.375 9.375-9.375 24.56 0 33.94s24.56 9.375 33.94 0l81.38-81.38 47.03 47.03a31.986 31.986 0 0 0 22.63 9.367c4.117 0 8.279-.809 12.25-2.43a31.985 31.985 0 0 0 19.75-29.56V296c-.91-13.3-10.71-24-24.91-24z"
  }));
}

const ForwardRef = React.forwardRef(DownLeftAndUpRightToCenterIcon);
export default ForwardRef;